import VueCookies from 'vue-cookies'

const agentTokenCookieName = 'AGENT_TOKEN'

export const readTokenFromCookie = () => VueCookies.get(agentTokenCookieName)

export const writeTokenToCookie = (token) => VueCookies.set(agentTokenCookieName, token, Infinity)

export const deleteTokenCookie = () => VueCookies.remove(agentTokenCookieName)
